import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCManageCommitteeMeetingsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Committee meetings conducted" />
    </Box>
  );
};
